import React from 'react';
import queryString from 'query-string';
import classNames from 'classnames';
import { analyticsService } from '@common/analytics';
import {
  isWebView, toCamelCase, getStartChatClickSource,
  isPG,
  paramOrNul,
  getDataFromStorage
} from '../../../../../common/config/utils';
import Const from '../../../../config/const';
import {
  isAdvisorBusy, getSectionForEvent, getClickSourceForEvent, getAvailableSalesPrice, formatLocalCurrency
} from '../../../../config/util';
import classes from './classes.module.scss';
import { freeMinIcon } from '../../img/free_min_icon';
import { getModePriceColor } from './style_config';

export const getAltMessage = ({ mode }) => {
  const altMessageForModes = { chat: 'Live chat', voice: 'Voice call', video: 'Video call' };
  return altMessageForModes[mode];
};

export const getModeTitle = ({ mode, name, t }) => {
  if (mode === 'chat') return t('advisor_profile.chat_mode_name');
  return name;
};

const triggerLogin = (args) => {
  const {
    completion, authPendingAction, displayRegister, mode
  } = args;
  authPendingAction(() => { completion(args); });
  let signUpFlow = '';
  switch (mode) {
    case 'voice': signUpFlow = 'voice profile'; break;
    case 'video': signUpFlow = 'video profile'; break;
    default: signUpFlow = 'chat profile'; break;
  }
  displayRegister({ shouldDisplay: true, signUpFlow });
};

export const onStartChat = ({
  id, name, profilePictureUrl, price,
  location, chatInit, startChat, mode, displayRegister, authPendingAction, requestParams, fxRate, currency
}) => {
  const { section } = location.state || {};
  const homepageSection = section;
  const startChatAction = () => {
    chatInit(id, name, profilePictureUrl, price, getStartChatClickSource(location), requestParams, fxRate, currency);
    startChat(
      id,
      parseFloat(price),
      profilePictureUrl,
      name,
      getStartChatClickSource(location),
      homepageSection,
      requestParams,
      fxRate,
      currency
    );
  };
  if (!window.currentUserId) {
    triggerLogin({
      name,
      profilePictureUrl,
      price,
      id,
      mode,
      displayRegister,
      authPendingAction,
      completion: startChatAction,
      requestParams
    });
    return;
  }
  startChatAction();
};

export const onStartVoip = ({
  id, name, profilePictureUrl, price,
  location, makeCallOrShowPopup, mode, displayRegister, authPendingAction, requestParams, fxRate, currency
}) => {
  const { section } = location.state || {};
  const homepageSection = section;
  const startVoipAction = () => {
    makeCallOrShowPopup({
      id, ppm: parseFloat(price), profilePictureUrl, name, startChatClickSource: getStartChatClickSource(location),
      homepageSection, voipType: mode === 'voice' ? Const.chatType.voice : Const.chatType.video, requestParams, fxRate, currency
    });
  };
  if (!window.currentUserId) {
    triggerLogin({
      name,
      profilePictureUrl,
      price,
      id,
      mode,
      displayRegister,
      authPendingAction,
      completion: startVoipAction,
      requestParams
    });
    return;
  }
  startVoipAction();
};

export const getImage = ({ mode, modeState, liveModes }) => {
  if (isWebView() && (mode === 'voice' || mode === 'video')) {
    return `${ mode }_offline`;
  }
  if (modeState === 'online') return `${ mode }_${ modeState }`;
  if (isAdvisorBusy({ liveModes })) return `${ mode }_busy`;
  return `${ mode }_offline`;
};

export const renderPrice = ({
  localPromoPrices, localPrice, userAdvisorModeSalePrice, modeState, mode, currency
}) => {
  const availableSalesPrice = getAvailableSalesPrice({ localPromoPrices, userAdvisorModeSalePrice, localPrice });
  return (
    <span className={ classes.modePrice } style={ { ...getModePriceColor(modeState, mode) } }>
      <span className={ availableSalesPrice ? classes.sale : '' }>
        {localPrice ? `${ formatLocalCurrency(localPrice, currency) }/min` : '\n'}
      </span>
      {availableSalesPrice && (
        <div>
          {`${ formatLocalCurrency(availableSalesPrice, currency) }/min`}
        </div>
      )}
    </span>
  );
};

export const trackProfileChatButtonAction = ({
  price, id, mode, location
}) => {
  const { section } = getSectionForEvent({ location });
  const { clickSource } = getClickSourceForEvent({ location });
  const payload = {
    ppm: parseFloat(price),
    tryout: false,
    'advisor id': id,
    'click source': clickSource,
    ...paramOrNul('section', section),
    ...paramOrNul('urgency sentence string', getDataFromStorage('advisor_urgency_signal_text'))
  };
  let eventName = '';
  switch (mode) {
    case 'voice':
      eventName = 'profile voice button';
      break;
    case 'video':
      eventName = 'profile vc button';
      break;
    default:
      eventName = 'profile chat button';
      break;
  }
  analyticsService.trackEvent(eventName, payload);
};

export const getAdvisorCTABtnClassName = ({ theme }) => {
  if (isPG()) return classes[`${ theme }`];
  return classNames(classes[`${ theme }`], classes.fullWidth);
};

const getAction = () => {
  const availableAction = { chat_init: 'chat', voice_init: 'voice', video_init: 'video' };
  const { action } = toCamelCase(queryString.parse(window.location.search));
  return availableAction[action];
};

export const makeActionIfNeed = ({
  mode, advisorCTAOnClick, location, history
}) => {
  const action = getAction();
  if (action === mode) {
    const search = toCamelCase(queryString.parse(location.search));
    delete search.action;
    const updatedSearch = queryString.stringify(search);
    history(`${ location.pathname }?${ updatedSearch }`, {
      search: updatedSearch,
      state: { ...location.state }
    });
    advisorCTAOnClick({ action });
  }
};

export const renderfreeMinLabel = (color, freeMinText) => (
  <div className={ classes.freeMinContainer } style={ { '--free-min-color': color } }>
    <div className={ classes.freeMinIcon }>{freeMinIcon({ color })}</div>
    <div className={ classes.freeMinTextContainer }>{freeMinText}</div>
  </div>
);
